import React, { useEffect, useRef, useState } from 'react'
import axios from 'axios';
import { Button } from '@mui/material';
import RosterModal from '../Modals/RosterModal';

function CSVImport(props) {
    const [ file, setFile ] = useState();
    const [openRoster, setOpenRoster] = useState(false);

    //roster modal
    const handleRosterModalOpen = () => setOpenRoster(true);
    const handleRosterModalClose = () => setOpenRoster(false);

    const hiddenFileInput = useRef(null);

    const checkFile = async(event) => {
        try {
            const token = JSON.parse(localStorage.getItem('user'));
            if(
                event.target.files[0].type === "text/csv"
                ){
                setFile(event.target.files[0]);
                await parseRoster(event.target.files[0], token);
                if (props.importProjects) {
                    await axios.put(`${props.host}/api/semester/updateGroups`,
                    {headers: {Authorization: `Bearer ${token.access_token}`}})
                }
                props.onClose();
                return;
            }else{
                event.target.value = null;
                alert("Invalid File Type: Please Upload .xls File Only.");
            }
        } catch(err){
            console.log("Error caught." + 
                "May have been when file was added " + 
                "to upload, then selected again for " + 
                "upload but cancelled: " + err);
        }   
    }

    function csvToArray(str, delimiter=",") {
        
        const headers = str.slice(0, str.indexOf("\n")).split(delimiter);
        const rows = str.slice(str.indexOf("\n")).split("\n");

        const arr = rows.map(function (row, set) {
            if(set > 1 && row.length > 1){
                const values = row.split(delimiter);

                values[0] = values[0].slice(1)
                values[1] = values[1].slice(1)
                values[1] = values[1].slice(0, -1)

                const el = headers.reduce(function (object, header, index) {
                    if (header === 'Student'){
                        object['last_name'] = values[index];
                        object['first_name'] = values[index + 1];
                    } else {
                        object[header] = values[index + 1];
                    }
                    return object;
                }, {});
                return el;
            }
        });
        const filteredArray = arr.filter(info => info !== undefined);
        return filteredArray;
    }

    const parseRoster = async(file, token) => {
        try {
            const reader = new FileReader();
            reader.readAsText(file);
            reader.onload = function (e) {
              
                const text = e.target.result;
                const data = csvToArray(text);

                axios.post(`${props.host}/api/csv/classCSV`,
                {
                    students: data,
                    class_id: props.class_id,
                },
                {
                    headers: {Authorization: `Bearer ${token.access_token}`}
                })
                .then(res => res.data)
                .then(props.loadStudentData())
                .catch(err => console.log(err))
            };

            handleRosterModalOpen();
        }catch(error){
            console.log("an error has occured with parsing xls file: " + error);
        }
    }
    
    const handleClick = event =>{
        //allow sub button to act as input button
        hiddenFileInput.current.click();
    }

    useEffect(() => {

    }, [file])

  return (
        
        <div id="upload-box">
            
            <Button onClick={handleClick} style={{width: '100%', backgroundColor: '#2E2E2E'}} variant='contained'>Import Roster</Button>
            <input type="file" ref={hiddenFileInput} style={{display:'none'}} onChange={checkFile} accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" />
            <RosterModal open={openRoster} handleClose={handleRosterModalClose} />

            {/* {enabled && 
                <button onClick={parseRoster}>Import Students</button>
            } */}
            {/* <p/> */}

        </div>

  )
}

export default CSVImport